module.exports = __webpack_public_path__ + "static/media/mint-asset.7d719af3.png";